import axios from "axios";
import { setupCache } from "axios-cache-interceptor";

export const axiosInstance = setupCache(axios.create({
  timeout: 30000, // 30 seconds
}), {
  ttl: 1000 * 60 * 5, // 5 minutes cache
  interpretHeader: false,
  methods: ['get', 'post'], // Cache both GET and POST requests
});
